
import {firebaseProjectConfigSandbox} from "./sandbox/firebaseProject"
import {firebaseProjectConfigStaging} from "./staging/firebaseProject"
import {firebaseProjectConfigProduction} from "./production/firebaseProject"

const firebaseProjectConfig = (process.env.VUE_APP_CONFIG_ENV === "ProductionConfigEnv") ? firebaseProjectConfigProduction : 
  ((process.env.VUE_APP_CONFIG_ENV === "StagingConfigEnv") ? firebaseProjectConfigStaging : firebaseProjectConfigSandbox)
export {
  firebaseProjectConfig
}